import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components, operations } from '@/lib/generated/api-types'

// Export type aliases from generated types for backward compatibility
export type AuditLog = components['schemas']['AuditLogResponse']
export type AuditLogsResponse = components['schemas']['AuditLogsResponse']
export type AuditLogsFilters = NonNullable<
  operations['query_audit_logs_api_v1_audit_logs_get']['parameters']['query']
>

/**
 * Hook to fetch audit logs with optional filters
 */
export function useAuditLogs(filters?: AuditLogsFilters) {
  return useQuery({
    queryKey: queryKeys.auditLogs.list(filters),
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/audit/logs', {
        params: {
          query: filters,
        },
      })

      if (error) throw error

      return data
    },
  })
}

/**
 * Hook to fetch a specific audit log by ID
 */
export function useAuditLog(logId: number, enabled = true) {
  return useQuery({
    queryKey: queryKeys.auditLogs.detail(logId),
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/audit/logs/{log_id}', {
        params: {
          path: {
            log_id: logId,
          },
        },
      })

      if (error) throw error

      return data
    },
    enabled,
  })
}
